export default "__VITE_ASSET__BEV81Z6c__"